// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1wX0R","messages":"Chat_messages__35O38","dateDivider":"Chat_dateDivider__35nKN"};